import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import type React from "react";
import { useState } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { NotificationSetting } from "~/components/specifics/vendors/settings/notifications/NotificationSetting";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: React.FC = () => {
	const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);

	return (
		<VendorLayoutV2>
			<VendorSettingLayout>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "設定一覧" },
							{ label: "アカウント詳細" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader
						rightArea={
							<Button
								onClick={() => {
									setIsNotificationModalOpen(true);
								}}
								variant="primary"
							>
								追加
							</Button>
						}
						title="通知設定"
					/>
					<PanelBody>
						<NotificationSetting
							isModalOpen={isNotificationModalOpen}
							onModalClose={() => {
								setIsNotificationModalOpen(false);
							}}
						/>
					</PanelBody>
				</Panel>
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
};
